import { BrigadeFormModal } from "@/modules/brigades/components/BrigadeFormModal";
import { BrigadeTable } from "@/modules/brigades/components/BrigadeTable";
import { useUrlTableState } from "@/shared/hooks/useUrlState";

interface OrgBrigadesTabProps {
	organizationId: string;
}

export function OrgBrigadesTab({ organizationId }: OrgBrigadesTabProps) {
	const { page, limit, setPage } = useUrlTableState({ prefix: "brig" });

	return (
		<>
			<BrigadeTable
				organizationId={organizationId}
				page={page}
				limit={limit}
				onPageChange={setPage}
			/>
			<BrigadeFormModal organizationId={organizationId} />
		</>
	);
}
